import isEqual from 'lodash/isEqual'
import type { IAutoSaveComparator } from './interfaces'

export const defaultComparator: IAutoSaveComparator = (prevValues, values) => !isEqual(prevValues, values)
